/**
 * Local SVG Icon Mappings
 * Maps icon names to their SVG imports
 */

import FacebookIcon from '@/icons/facebook.svg'
import GithubIcon from '@/icons/github.svg'
import InstagramIcon from '@/icons/instagram.svg'
import LinkedinIcon from '@/icons/linkedin.svg'
import PinterestIcon from '@/icons/pinterest.svg'
import TiktokIcon from '@/icons/tiktok.svg'
import TwitterIcon from '@/icons/twitter.svg'
import YoutubeIcon from '@/icons/youtube.svg'

export const icons = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  youtube: YoutubeIcon,
  tiktok: TiktokIcon,
  github: GithubIcon,
  pinterest: PinterestIcon,
} as const

// Re-export registry types and metadata
export { type LocalIconName, localIconNames, localIcons } from '@/icons/registry'
